import { FETCH_MANIFESTS } from "./types";
import axios from "axios";

export const fetchManifests = (queryString, options, payload) => dispatch => {
  dispatch({
    type: FETCH_MANIFESTS,
    payload: [],
    keyword: "",
    isFetching: true,
    options: options
  });

  delete options.total_records;

  axios.get(`api/v1/hwts/search/manifests${queryString}`).then(results => {
    dispatch({
      type: FETCH_MANIFESTS,
      payload: results.data.data.manifests,
      isFetching: false,
      options: results.data.data.filters[0],
      keyword: results.data.data.filters[0].keyword
    });
  });
};